import type { HTMLAttributes } from 'react'
import { cn } from '@/lib/utils'
import type { UpboTag } from '@/types'

interface ContainerProps extends HTMLAttributes<HTMLDivElement>, UpboTag {
  size?: 'sm' | 'md' | 'lg' | 'xl'
}

const sizes = {
  sm: 'max-w-3xl',
  md: 'max-w-5xl',
  lg: 'max-w-7xl',
  xl: 'max-w-[1480px]',
}

/** Khung căn giữa chuẩn — mọi khối nội dung của site đều bọc trong này. */
export function Container({ children, className, size = 'lg', ...props }: ContainerProps) {
  return (
    <div className={cn('w-full mx-auto px-4 sm:px-6 lg:px-8', sizes[size], className)} {...props}>
      {children}
    </div>
  )
}
